import { render, staticRenderFns } from "./ModalGlobalFilter.vue?vue&type=template&id=2b281b0c&scoped=true&"
import script from "./ModalGlobalFilter.vue?vue&type=script&lang=js&"
export * from "./ModalGlobalFilter.vue?vue&type=script&lang=js&"
import style0 from "./ModalGlobalFilter.vue?vue&type=style&index=0&id=2b281b0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b281b0c",
  null
  
)

export default component.exports